<script>
    import { configPanel } from "../../../../Controller/analytics/configPanel";
    import { panelController, updateService } from "../../../../stores/service";
    import ListPreguntas from "../../../../views/admin/analytics/panels/editListPreguntas.svelte";

    import { navigate } from "svelte-routing";
    document.title = "Ratingg | Lista de ratinggs";

    export let panelist = {
        date: "",
        name: "",
        edit: true,
        inputs: {
            name: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            modo: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            autenticacion: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            opcpin: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            pin: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
        },
    };

    let data;

    let panelcofig;

    function main() {
        panelcofig = new configPanel(panelist.service, panelist.index);
        reset();
    }

    function reset() {
        data = panelcofig.dataView;
    }

    main();
    /* function firebaseLikeId() {
        const chars = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
        let id = '';
        let now = Date.now();

        // parte de tiempo (8 chars)
        for (let i = 7; i >= 0; i--) {
            id = chars[now % 64] + id;
            now = Math.floor(now / 64);
        }
        // parte random (12 chars)
        for (let i = 0; i < 12; i++) {
            id += chars[Math.floor(Math.random() * 64)];
        }
        return id;
    } */

    /* function name() {
        let id = firebaseLikeId();
        let setdata = new modelAnalytics();

        const porAnioMes = $panelController.viewSondeosPanel.ratinggs.reduce(
            (acc, ratinggdata) => {
                const date = ratinggdata.date.toDate();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;

                if (!acc[year]) acc[year] = [];
                if (!acc[year][month]) acc[year][month] = [];

                acc[year][month].push(ratinggdata);

                return acc;
            },
            {},
        );

        let documento = [];

        Object.entries(porAnioMes).forEach(([key, property]) => {
            property.forEach((elementmes) => {
                const fdate = elementmes[0].date.toDate();
                const pyear = fdate.getFullYear();
                const pmonth = fdate.getMonth() + 1;

                setdata.Crear({
                    mes: pmonth.toString(),
                    year: pyear.toString(),
                    data: elementmes,
                    id: id,
                });
            });
        });
    } */
    function shareDoc(texto) {
        // Crear un nuevo elemento de textarea para copiar el texto
        const textarea = document.createElement("textarea");

        textarea.value = texto;
        document.body.appendChild(textarea);
        // Seleccionar y copiar el texto
        textarea.select();
        document.execCommand("copy");
        // Eliminar el elemento textarea (ya no es necesario)
        document.body.removeChild(textarea);
        window.open(texto, "_blank");
    }

    function save() {
        if (!data.inputs.modo.valid.valid || !data.inputs.name.valid.valid) {
            return;
        }

        if (data.inputs.opcpin.value) {
            if (!data.inputs.pin.valid.valid) {
                return;
            }
        }

        /*  panelcofig.reset(panelcofig.setData(data)) */

        $panelController.service = panelcofig.setData(data.inputs);
        updateService();
        reset();
    }

    function btn_cancelar() {
        panelcofig.reset(panelcofig.config);
        reset();
    }

    function validMode() {
        /* console.log(this.dataView.inputs.modo.value,this.dataView,value); */

        if (data.inputs.modo.value == 0) {
            data.inputs.modo.valid.text = "No valido";
            data.inputs.modo.valid.style = "valid-i";
            data.inputs.modo.valid.valid = false;
        } else {
            data.inputs.modo.valid.text = "Selecionado";
            data.inputs.modo.valid.style = "valid-c";
            data.inputs.modo.valid.valid = true;
        }
    }

    function btn_editar() {
        data.edit = false;
        panelcofig.dataView = data;
    }

    function validLogin() {
        console.log(data.inputs.autenticacion);
        if (data.inputs.autenticacion.value) {
            data.inputs.autenticacion.valid.text = "Activado";
            data.inputs.autenticacion.valid.style = "valid-c";
            data.inputs.autenticacion.valid.valid = true;
        } else {
            data.inputs.autenticacion.valid.text = "Desactivado";
            data.inputs.autenticacion.valid.style = "valid-i";
            data.inputs.autenticacion.valid.valid = false;
        }
    }

    function validName() {
        const ep = /^[0-9\w'\-,.][^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,30}$/;

        if (ep.test(data.inputs.name.value)) {
            data.inputs.name.valid.text = "Nombre valido";
            data.inputs.name.valid.style = "valid-c";
            data.inputs.name.valid.valid = true;
        } else {
            data.inputs.name.valid.text =
                "El nombre contiene un carácter no valido o es corto";
            data.inputs.name.valid.style = "valid-i";
            data.inputs.name.valid.valid = false;
        }
    }

    function validPINCheck() {
        if (data.inputs.opcpin.value) {
            data.inputs.opcpin.valid.text = "Activado";
            data.inputs.opcpin.valid.style = "valid-c";
            data.inputs.opcpin.valid.valid = true;
            data.inputs.pin.valid.valid = false;
            data.inputs.opcpin.valid.valid = false;
            data.inputs.pin.valid.text = "El PIN debe contener 4 dígitos";
        } else {
            data.inputs.opcpin.valid.text = "Desactivado";
            data.inputs.opcpin.valid.style = "valid-i";
        }
    }

    function validPN() {
        const ep = /^\d{4}$/;
        if (ep.test(data.inputs.pin.value)) {
            data.inputs.pin.valid.text = "PIN valido";
            data.inputs.pin.valid.style = "valid-c";
            data.inputs.pin.valid.valid = true;
        } else {
            data.inputs.pin.valid.text = "El PIN debe contener 4 dígitos";
            data.inputs.pin.valid.style = "valid-i";
            data.inputs.pin.valid.valid = false;
        }
    }
</script>

<div class="card text-center">
    <div class="card-header">
        <div class="row center">
            <!-- <h3 class='text-sm text-md-lg'>{item.name}</h3>  -->
            <label for="title">{data.name}</label>
        </div>
    </div>
    <div class="card-body">
        <!-- Input de texto -->
        <div class="row">
            <div class="row">
                <label for="date">Fecha: {data.date}</label>
            </div>
            <div class="row">
                <div class="form-group col-md-8">
                    <label for="numero1">Nombre de la encuesta</label>
                    <input
                        type="text"
                        class="form-control"
                        bind:value={data.inputs.name.value}
                        on:input={() => validName()}
                        disabled={data.edit}
                    />
                    <!-- data -->
                    <p class={data.inputs.name.valid.style}>
                        {data.inputs.name.valid.text}
                    </p>
                </div>
                <div class="form-group col-md-4">
                    <label for="numero2">Modo:</label>
                    <select
                        class="form-select"
                        aria-label="Default"
                        bind:value={data.inputs.modo.value}
                        disabled={data.edit}
                        on:change={() => validMode()}
                    >
                        <option selected value={0}>Seleccione una opción</option
                        >
                        <option value={1}>Normal</option>
                        <option value={2}>Rápida</option>
                        <option value={3}>Cuestionario</option>
                    </select>
                    <p class={data.inputs.modo.valid.style}>
                        {data.inputs.modo.valid.text}
                    </p>
                </div>
            </div>
            <!-- Dos campos numéricos -->
            <div class="row">
                <div class="form-group col-md-6">
                    <div class="form-check form-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckDefault"
                            bind:checked={data.inputs.autenticacion.value}
                            disabled={data.edit}
                            on:change={() => validLogin()}
                        />
                        <label for="flexSwitchCheckDefault"
                            >Autenticación de usuarios</label
                        >
                    </div>
                    <p class={data.inputs.autenticacion.valid.style}>
                        {data.inputs.autenticacion.valid.text}
                    </p>
                </div>
                <div class="form-group col-md-6">
                    <div class="form-check form-switch">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckDefault1"
                            bind:checked={data.inputs.opcpin.value}
                            disabled={data.edit}
                            on:change={() => validPINCheck()}
                        />
                        <label for="flexSwitchCheckDefault">PIN</label>
                    </div>
                    <p class={data.inputs.opcpin.valid.style}>
                        {data.inputs.opcpin.valid.text}
                    </p>
                </div>
            </div>

            <div class="row">
                {#if data.inputs.opcpin.value}
                    <div class="form-group col-md-12">
                        <label for="numero2">PIN:</label>
                        <input
                            type="number"
                            class="form-control"
                            id="numero2"
                            name="numero2"
                            bind:value={data.inputs.pin.value}
                            on:input={() => validPN()}
                            disabled={data.edit}
                        />
                        <p class={data.inputs.pin.valid.style}>
                            {data.inputs.pin.valid.text}
                        </p>
                    </div>
                {/if}
            </div>
        </div>
    </div>
    <div class="card-footer text-body-secondary">
        {#if !data.edit}
            <button
                class="btn btn-light m-1"
                on:click={() => {
                    save();
                }}
                >Guardar
                <i class="bi bi-check2-circle"></i>
            </button>

            <button
                class="btn btn-light m-1"
                on:click={() => {
                    btn_cancelar();
                }}
                >Cancelar
                <i class="bi bi-x-circle"></i>
            </button>
        {/if}

        {#if data.edit}
            <button
                class="btn btn-light m-1"
                on:click={() => {
                    btn_editar();
                }}
                >Editar
                <i class="bi bi-pencil-square"></i>
            </button>

            <button
                class="btn btn-light m-1"
                on:click={() => {
                    shareDoc(
                        `${window.location.origin}/?id=${$panelController.service.idServices}&key=${$panelController.service.listRatinggs[panelcofig.index].config.id}`,
                    );
                }}
                >link compartir
                <i class="bi bi-share-fill"></i>
            </button>
        {/if}
    </div>
</div>

<ListPreguntas data={{ service: panelist.service, index: panelist.index }} />

<style>
    .form-control {
        text-align: center;
    }
    .valid-c {
        color: green;
    }
    .valid-i {
        color: red;
    }
</style>
